import {getBookInfo_api} from '@/api/bookManage'
import {getVolumeList_api} from '@/api/volume'

const app = {
	namespaced: true,
	state: {
		volumeList: [],
		bookInfo: {},

	},
	getters: {
		bookInfo: state => {
			let bookVO = state.bookInfo.bookVO || {}
			let bookDetailVO = state.bookInfo.bookDetailVO || {}
			return {
				price: bookVO.price,
				inspectName: bookVO.inspectName,
				inspectIntroduction: bookVO.inspectIntroduction,
				tags: bookVO.tags,
				cpIdText: bookVO.cpIdText,
				cpId: bookVO.cpId,
				bookCategoryPathList: state.bookInfo.bookCategoryPathList || [],
				bookMajor: bookDetailVO.bookMajor,
				bookMinor: bookDetailVO.bookMinor,
				words: bookVO.words,
				id: bookVO.id,
				inspectShareIntroduction: bookVO.inspectShareIntroduction,
				finish: bookVO.finish,
				hidden: bookVO.hidden,
				bookType: bookVO.bookType
			}
		}
	},
	mutations: {
		setVolumesMutation: (state, data) => {
			state.volumeList = data
		},

		setBookInfoMutation: (state, data) => {

			state.bookInfo = data
		},


	},

	actions: {

		// 获取所有卷
		async getVolumesAction({commit}, bookId) {

			let res = await getVolumeList_api(bookId)
			commit('setVolumesMutation', res.data.items)
		},

		// 获取作品信息
		async getBookInfoAction({commit}, bookId) {
			let res = await getBookInfo_api(bookId)
			if (res.data.items) {
				commit('setBookInfoMutation', res.data.items)
			}
			return Promise.resolve(res.data.items)
		}


	}
}
export default app



// WEBPACK FOOTER //
// ./src/store/bookManage.js